import { authSaga } from '../faetures/auth/authSaga';
import { monHocSaga } from '../faetures/mon-hoc/monHocSaga';
import { all } from 'redux-saga/effects';

export default function* rootSaga() {
    yield all([monHocSaga(), authSaga()]);
}
